import { AbstractControl, AsyncValidatorFn, FormGroup, ValidatorFn } from '@angular/forms';
import { FormUtils } from '@bca-shared/shared.utils';

export class Form<T> {
  constructor(public formGroup?: FormGroup) {}

  public setFormGroup(formGroup: FormGroup): void {
    this.formGroup = formGroup;
  }

  public clearValidators(control?: AbstractControl): void {
    if (control) {
      control.clearValidators();
    } else if (this.formGroup) {
      this.formGroup.clearValidators();
    }
  }

  public setValidators(newValidator: ValidatorFn | ValidatorFn[], control?: AbstractControl): void {
    if (control) {
      control.setValidators(newValidator);
    } else if (this.formGroup) {
      this.formGroup.setValidators(newValidator);
    }
  }

  public clearAsyncValidators(control?: AbstractControl): void {
    if (control) {
      control.clearAsyncValidators();
    } else if (this.formGroup) {
      this.formGroup.clearAsyncValidators();
    }
  }

  public setAsyncValidators(
    newValidator: AsyncValidatorFn | AsyncValidatorFn[],
    control?: AbstractControl
  ): void {
    if (control) {
      control.setAsyncValidators(newValidator);
    } else if (this.formGroup) {
      this.formGroup.setAsyncValidators(newValidator);
    }
  }

  public resetValue(value?: T): void {
    if (this.formGroup) {
      if(value){
        this.formGroup.reset(value, { emitEvent: false });
      }
      else{
        this.formGroup.reset();
      }
    }
  }

  public patchValue(value: T): void {
    if (this.formGroup) this.formGroup.patchValue(value, { emitEvent: false });
  }

  public setValue(value: T): void {
    if (this.formGroup) this.formGroup.setValue(value, { emitEvent: false });
  }

  public touchControls(controls?: { [key: string]: AbstractControl }): void {
    if (this.formGroup) FormUtils.touchControls(controls ? controls : this.formGroup.controls);
  }

  public getControl<C extends AbstractControl>(key: string): C {
    return this.formGroup && (FormUtils.getControl(key, this.formGroup) as C);
  }

  public isTouchedAndDirty(key: string): boolean {
    return this.formGroup && FormUtils.isTouchedAndDirty(key, this.formGroup);
  }

  public isDirty(key: string): boolean {
    return this.formGroup && FormUtils.isDirty(key, this.formGroup);
  }

  public isTouched(key: string): boolean {
    return this.formGroup && FormUtils.isTouched(key, this.formGroup);
  }

  public hasError(key: string, errorCode: string): boolean {
    return this.formGroup && FormUtils.hasError(key, errorCode, this.formGroup);
  }

  public getValue(key: string): any {
    return this.formGroup && FormUtils.getValue(key, this.formGroup);
  }
}
